import { trace } from '@opentelemetry/api';
import {
  CollectorExporterNodeConfigBase,
  CollectorTraceExporter,
} from '@opentelemetry/exporter-collector';
import { Resource } from '@opentelemetry/resources';
import { BatchSpanProcessor, BufferConfig, NoopSpanProcessor } from '@opentelemetry/sdk-trace-base';
import { WebTracerProvider } from '@opentelemetry/sdk-trace-web';
import { SemanticResourceAttributes } from '@opentelemetry/semantic-conventions';
import ElectronHelper from './common/electron/ElectronHelper';
import { RetailElectronAPI } from './common/electron/RetailElectronAPI';

const { REACT_APP_ENABLE_TRACING } = ElectronHelper.isElectron()
  ? RetailElectronAPI.getEnvironmentVariables()
  : process.env;

const ENABLE_TRACING = REACT_APP_ENABLE_TRACING === 'true';

const collectorOptions: CollectorExporterNodeConfigBase = {
  url: '/v1/trace',
  headers: {},
};

const batchBufferConfig: BufferConfig = {
  // The maximum batch size of every export. It must be smaller or equal to maxQueueSize.
  maxExportBatchSize: 10,
  // The interval between two consecutive exports
  scheduledDelayMillis: 500,
  // How long the export can run before it is cancelled
  exportTimeoutMillis: 30000,
};

export const initializeTracer = (): void => {
  const provider = new WebTracerProvider({
    resource: new Resource({
      [SemanticResourceAttributes.SERVICE_NAME]: 'XLR-POS',
    }),
  });

  provider.addSpanProcessor(
    ENABLE_TRACING
      ? new BatchSpanProcessor(new CollectorTraceExporter(collectorOptions), batchBufferConfig)
      : new NoopSpanProcessor(),
  );

  provider.register();
};

export default trace.getTracer('tracer');
